module.exports = __webpack_public_path__ + "img/curved8.94c41fab.jpg";